import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
    faBug,
    faHome,
    faDashboard,
    faAngleUp,
    faAngleDown,
    faAngleRight,
    faNavicon,
    faTimes,
    faInfoCircle,
    faEye,
    faEyeSlash,
    faSpinner,
    faCalendar,
    faHistory,
    faMoneyCheck,
    faUser,
    faDownload,
    faCommentAlt,
    faCubes,
    faArrowLeft,
    faArrowRight,
    faSignIn,
    faWrench,
    faSave,
    faCheck,
    faCheckCircle,
    faSearch,
    faLandmark,
    faMoneyBillTransfer,
    faImage,
    faPaperPlane,
    faSignOut,
    faEdit,
    faPlus,
    faTrash,
    faCopy,
    faMoneyBillTrendUp,
    faPrint,
    faFile,
    faRefresh,
    faReply,
    faMoneyCheckDollar,
    faGear,
    faPaste,
    faBox,
} from "@fortawesome/free-solid-svg-icons";

import {
    faCircle,
    faCircleDot
} from "@fortawesome/free-regular-svg-icons"

import {
    faFacebook,
    faInstagram,
    faYoutube,
    faTwitter,
    faWhatsapp
} from "@fortawesome/free-brands-svg-icons"

library.add(
    faBug,
    faHome,
    faDashboard,
    faAngleUp,
    faAngleDown,
    faAngleRight,
    faNavicon,
    faTimes,
    faInfoCircle,
    faEye,
    faEyeSlash,
    faSpinner,
    faCalendar,
    faHistory,
    faMoneyCheck,
    faUser,
    faDownload,
    faCommentAlt,
    faCubes,
    faArrowLeft,
    faArrowRight,
    faSignIn,
    faWrench,
    faSave,
    faCheck,
    faCheckCircle,
    faSearch,
    faLandmark,
    faMoneyBillTransfer,
    faImage,
    faPaperPlane,
    faSignOut,
    faEdit,
    faPlus,
    faTrash,
    faCopy,
    faCircle,
    faCircleDot,
    faMoneyBillTrendUp,
    faFacebook,
    faInstagram,
    faYoutube,
    faTwitter,
    faWhatsapp,
    faPrint,
    faFile,
    faRefresh,
    faReply,
    faMoneyCheckDollar,
    faGear,
    faPaste,
    faBox,
);

export default {
    install(app) {
        app.component("fa-icon", FontAwesomeIcon);
    }
}